import { render } from "./BaseBanner.vue?vue&type=template&id=54546ece&scoped=true"
import script from "./BaseBanner.vue?vue&type=script&lang=js"
export * from "./BaseBanner.vue?vue&type=script&lang=js"

import "./BaseBanner.vue?vue&type=style&index=0&id=54546ece&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54546ece"]])

export default __exports__